<template>
  <div class="account-safety-level-setting">
    <!-- 查询条件 -->
    <vab-query-form>
      <vab-query-form-left-panel :span="18" />
      <vab-query-form-right-panel :span="6">
        <el-button :disabled="!tableData.length" @click="tagLevelSettingModal.open()">分值区间设置</el-button>
        <el-button icon="search" type="primary" @click="query()">查询</el-button>
      </vab-query-form-right-panel>
    </vab-query-form>
    <!-- 表格 -->
    <el-table v-loading="loading" border :data="tableData" table-layout="auto">
      <el-table-column label="分级名称">
        <template #default="{ row }">
          {{ optionsMap[TAG_LEVEL]?.[row.type] || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="分值区间">
        <!-- <template #header>
          <el-row type="flex" justify="space-between" align="middle">
            <span>标记分级</span>
            <el-link type="primary" :underline="false" icon="tools" @click="tagLevelSettingModal.open()">
              分值区间设置
            </el-link>
          </el-row>
        </template> -->
        <template #default="{ row }">
          <!-- {{ row._分值区间.replace(',', '-') }} -->
          {{ row.minScore + '-' + row.maxScore }}
        </template>
      </el-table-column>
      <el-table-column label="功能限制">
        <template #default="{ row }">
          <!-- {{
            row._功能限制
              .split(',')
              .map((e) => optionsMap[ACCOUNT_SECURITY_RESTRICTIONS][e])
              .join(', ')
          }} -->
          {{ row.description }}
        </template>
      </el-table-column>
      <template #empty>
        <el-empty class="vab-data-empty" description="暂无数据" />
      </template>
    </el-table>

    <!-- 标记分级配置 -->
    <el-dialog
      destroy-on-close
      :model-value="tagLevelSettingModal.visible"
      title="标记分级配置"
      :width="640"
      @closed="tagLevelSettingModal.close"
    >
      <TagLevelSetting ref="tagLevelSettingRef" :options="tableData" @success="onTagLevelSettingSuccess" />
      <template #footer>
        <el-button @click="tagLevelSettingModal.close">取消</el-button>
        <el-button type="primary" @click="tagLevelSettingRef.submit()">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
  import { onMounted, ref, reactive } from 'vue'
  import { omit } from 'lodash'
  import { getComplaintJSON, getViolationConfigList } from '@/api/jbh'
  import { useModal } from '@/hooks/useModal'
  import TagLevelSetting from './TagLevelSetting.vue'

  const defaultQueryParams = {
    pageNum: 1,
    pageSize: 20,
    total: 0,
  }

  const queryParams = reactive({ ...defaultQueryParams })

  const loading = ref(false)
  const tableData = ref([])

  const TAG_LEVEL = 'TAG_LEVEL'
  const ACCOUNT_SECURITY_RESTRICTIONS = 'ACCOUNT_SECURITY_RESTRICTIONS'
  const options = ref({})
  const optionsMap = ref({})

  onMounted(() => {
    query()
    getOptions()
  })

  function query(pageNum = queryParams.pageNum) {
    const params = {
      ...omit(queryParams, 'total'),
      pageNum,
    }

    loading.value = true

    getViolationConfigList(params)
      .then(({ code, data }) => {
        if (code !== 200) return
        const { list, total } = data
        tableData.value = list
        queryParams.total = total
      })
      .finally(() => {
        loading.value = false
      })
  }

  function getOptions() {
    getComplaintJSON().then((res) => {
      const map = {},
        opt = {}
      ;[ACCOUNT_SECURITY_RESTRICTIONS, TAG_LEVEL].forEach((key) => {
        const data = res.options[key]
        if (!Array.isArray(data)) return
        data.forEach(([value, label]) => {
          if (!map[key]) map[key] = {}
          if (!opt[key]) opt[key] = []
          map[key][value] = label
          opt[key].push({ value, label })
        })
      })
      options.value = opt
      optionsMap.value = map
    })
  }

  const tagLevelSettingRef = ref()
  const tagLevelSettingModal = useModal()

  function onTagLevelSettingSuccess() {
    query()
    tagLevelSettingModal.close()
  }
</script>

<style lang="scss" scoped>
  .account-safety-level-setting {
    padding: 16px;
  }
</style>
